import ModalInput from '@/common/components/base/input/modalInput/ModalInput';
import FreeZonePlateInput from '@/common/components/base/input/plate/freeZonePlateInput/FreeZonePlateInput';
import { FreePlateEmptyRules } from '@/common/components/base/input/plate/freeZonePlateInput/freeZonePlateInput.rules';
import { FreeZonePlateValue } from '@/common/components/base/input/plate/freeZonePlateInput/freeZonePlateInput.type';
import VehiclePlateInput from '@/common/components/base/input/plate/vehiclePlateInput/VehiclePlateInput';
import { VehiclePlateEmptyRules } from '@/common/components/base/input/plate/vehiclePlateInput/vehiclePlateInput.rules';
import { plateValue } from '@/common/components/base/input/plate/vehiclePlateInput/vehiclePlateInput.type';
import usePlateDesignRequest from '@/common/hooks/usePlateDesignRequest';
import useVehicleTypeRequest from '@/common/hooks/useVehicleTypeRequest';
import { Controller, useFormContext } from 'react-hook-form';
import { css } from 'styled-system/css';

const PlateSelection = ({
  plateDesign,
  onChangeFunctions: { plateDesignOnChange, freeZonePlateOnChange },
  vehicleTypeName = 'vehicle_type',
  plateDesignName = 'plate_design',
  vehiclePlateType,
}: {
  plateDesign: 'country' | 'free_zone';
  onChangeFunctions: {
    plateDesignOnChange: () => void;
    freeZonePlateOnChange: (value: FreeZonePlateValue) => void;
  };
  values: {
    plate: plateValue | FreeZonePlateValue;
  };
  plateDesignName?: string;
  vehicleTypeName?: string;
  requiredError?: string;
  vehiclePlateType: { enName: string; value: number };
}) => {
  const {
    vehicleTypeQuery: { data: vehicleTypeOptions },
  } = useVehicleTypeRequest({
    enabled: true,
  });

  const {
    plateDesignQuery: { data: plateDesignOptions },
  } = usePlateDesignRequest({
    enabled: true,
  });

  const methodContext = useFormContext();
  return (
    <>
      <ModalInput
        options={vehicleTypeOptions}
        name={vehicleTypeName ?? 'vehicle_type'}
        label="نوع وسیله‌نقلیه"
        inputProps={{ className: css({ mt: '0.5rem' }) }}
      />
      <ModalInput
        options={plateDesignOptions}
        onChange={plateDesignOnChange}
        name={plateDesignName ?? 'plate_design'}
        label="طرح پلاک"
      />

      {plateDesign !== 'free_zone' &&
      vehiclePlateType?.enName !== 'motorcycle' ? (
        <Controller
          name="plate"
          rules={{
            validate: VehiclePlateEmptyRules,
          }}
          render={({ field, fieldState }) => {
            return (
              <VehiclePlateInput
                onChange={(v) => {
                  field.onChange(v);
                  if (methodContext.formState.touchedFields.plate) {
                    methodContext.trigger('plate');
                  }
                }}
                value={field.value}
                requiredError={fieldState.error?.message}
              />
            );
          }}
        />
      ) : (
        <Controller
          name="plate"
          rules={{
            validate: (value) =>
              FreePlateEmptyRules(
                value,
                vehiclePlateType?.enName === 'motorcycle' &&
                  plateDesign === 'free_zone',
              ),
          }}
          render={({ field, fieldState }) => {
            return (
              <FreeZonePlateInput
                onChange={(v) => {
                  field.onChange(v);
                  if (methodContext.formState.touchedFields.plate) {
                    methodContext.trigger('plate');
                  }
                  freeZonePlateOnChange(v);
                }}
                value={field.value}
                requiredError={fieldState.error?.message}
                vehicle_plate_design={plateDesign ?? 'country'}
                vehicle_type_id={vehiclePlateType?.value ?? 1}
              />
            );
          }}
        />
      )}
    </>
  );
};
export default PlateSelection;
